export enum FunctionMode {
    Edit = 'edit',
    Label = 'label',
    Custom = 'custom'
}
